/* eslint-disable @typescript-eslint/naming-convention */

export interface PegaAssignments {
    pxObjClass: string;
    assignments: PegaAssignment[];
}

export interface PegaAssignment {
    caseID: string;
    caseTypeID: string;
    executedDeadlineTime: string;
    executedGoalTime: string;
    ID: string;
    instructions: string;
    name: string;
    pxObjClass: string;
    routedTo: string;
    scheduledDeadlineTime: string;
    scheduledGoalTime: string;
    type: string;
    urgency: string;
}

export interface PegaAssignmentAction {
    ID: string;
    name: string;
    pxObjClass: string;
    type: string;
}

export interface PegaPaginatedCasesResult {
    cases: [{ [key: string]: string }];
    content: {
        pyPaging: {
            pyMaxResultCount: string;
            pyPageCount: string;
            pyPageIndex: string;
            pyPageSize: string;
        };
    };
    showColumns: { [key: string]: string };
}

export interface PegaCDHContainerRequest {
    channel: string;
    containerName: string;
    externalID?: string;
    contextName: string;
    direction: string;
    subjectID: string;
    placements?: string;
    contexts?: PegaCDHContainerContext[];
}

export interface PegaCDHContainerContext {
    key?: string;
    value?: string;
    type?: string;
}

export interface PegaCDHContainerResponse {
    Status: string;
    ContainerList: PegaCDHContainerResponseContainer[];
}

export interface PegaCDHContainerResponseContainer {
    Status: string;
    ContainerName: string;
    RankedResults: PegaCDHContainerOffer[];
}

export interface PegaCDHContainerOffer {
    Category?: NBACategory;
    ClickThroughURL?: string;
    ContentURL?: string;
    Group?: string;
    Identifier?: string;
    ImageURL?: string;
    InteractionID?: string;
    Issue?: string;
    Name?: string;
    Rank?: number;
    VB_Title?: string;
    VB_Button_LinkLabel?: string;
    VB_Button_LinkLabel_Small?: string;
    VB_ContentText?: string;
    VB_ContentText_Large?: string;
    VB_ContentUrl_Type?: string;
    VB_ImageURL_Icon?: string;
    VB_ImageURL_Small?: string;
    VB_ImageURL_Medium?: string;
    VB_ImageURL_Large?: string;
    NBAType?: string;
}

export interface Context {
    Type: string;
    Value: string;
    Key: string;
}

export interface PegaNextBestActionBody {
    ContainerName: string;
    Resource: string;
    CustomerID: string;
    Channel: string;
    Direction: string;
    ContextName: string;
    Contexts: Context[];
}

export enum Channel {
    WEB = 'Web',
    MOBILE = 'Mobile'
}

export interface NextBestAction {
    title: string;
    text: string;
    containerOffer?: PegaCDHContainerOffer;
    link?: string;
    linkText?: string;
    notifyLink?: string;
    category?: NBACategory;
    clickThrough?: boolean;
    iconUrl?: string;
    name?: string;
    interactionID?: string;
    group?: string;
    issue?: string;
    identifier?: string;
    rank?: number;
    NBAType?: NBAType;
}

export enum NBAType {
    DEFAULT = 'Default',
    OBLIGATORY = 'Obligatory',
    OBLIGATORY_WITH_BUTTON = 'ObligatoryWithButton',
    OPEN_ON_LOGIN = 'OpenOnLogin',
    BLOCKING = 'Blocking'
}

export enum NBAOutcome {
    IMPRESSION = 'Impression',
    CLICKED = 'Clicked',
    REJECTED = 'Rejected',
    PERMANENTREJECTED = 'PermanentReject'
}

export enum NBACategory {
    MAINTENANCE = 'Maintenance',
    OTHER = 'Other'
}
